import { useState } from "react";

export default function DragNDrop({picture=null, setPicture}){

    const [file, setFile] = useState(null); // Pour stocker le fichier sélectionné

  // Gestion de la sélection d'image
  const handleImageChange = (e) => {
    const imageFile = e.target.files[0]; // Récupérer le premier fichier sélectionné
    setFile(imageFile); // Stocker le fichier pour un éventuel envoi au serveur

    if (imageFile) {
      const reader = new FileReader(); // Créer un FileReader pour lire le fichier
      reader.onload = (event) => {
        setPicture(event.target.result); // Stocker l'URL de l'image pour la prévisualisation
      };
      reader.readAsDataURL(imageFile); // Lire le fichier comme URL de données (base64)
    }
  };
  
    return (

        <div className="flex items-center justify-center w-full">
            <label for="dropzone-file" className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600">
                {!picture && <div className="flex flex-col items-center justify-center pt-5 pb-6">
                    <svg className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 16">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"/>
                    </svg>
                    <p className="mb-2 text-sm text-gray-500 dark:text-gray-400"><span className="font-semibold">Click to upload</span> or drag and drop</p>
                    <p className="text-xs text-gray-500 dark:text-gray-400">SVG, PNG, JPG or GIF</p>
                </div>}
                <input id="dropzone-file" type="file" className="hidden" accept="image" onChange={handleImageChange}/>
                {picture && <img
                  id="dropzone-file"
                  src={picture}
                  alt="Prévisualisation"
                  className="object-cover w-64 h-64"
                />}
            </label>

            
        </div> 

    )
}